<template>
  <o-modal
    ref="modal"
    :options="[
      { text: $t('general.cancel'), type: 'cancel' },
      { text: $t('general.print'), type: 'confirm', callback: handlePrint }
    ]"
    modal-class="receipt m-2 shadow-lg pointer-events-auto overflow-hidden sm:max-w-xs sm:w-full h-full max-h-lg"
    content-class="mx-auto max-w-xs h-full flex flex-col bg-white"
  >
    <o-scroll>
      <div v-if="reservation" id="receipt-content" class="text-left w-full text-sm py-4 px-4">
        <div class="overflow-auto">
          <div class="text-center">
            <img v-if="logo" :src="logo" :alt="title" class="mb-3 w-8 h-8 inline-block">
            <h2 class="text-base font-semibold">
              {{ title }}
            </h2>
            <p>
              {{ address }}
            </p>
          </div>
        </div>

        <div class="mt-10">
          <div class="text-sm flex font-semibold mb-1">
            <div class="flex-grow uppercase">
              {{ $t('general.customer') }}
            </div>
            <div>
              {{ reservation.customer.displayName }}
            </div>
          </div>
          <div class="text-sm flex font-semibold mb-1">
            <div class="flex-grow uppercase">
              {{ $t('general.date') }}
            </div>
            <div>
              {{ reservation.dateLabel }}
            </div>
          </div>
          <div class="text-sm flex font-semibold mb-1">
            <div class="flex-grow uppercase">
              {{ $t('general.time') }}
            </div>
            <div>
              {{ reservation.startLabel }}
            </div>
          </div>
          <div class="text-sm flex font-semibold mb-1">
            <div class="flex-grow uppercase">
              {{ $t('general.price') }}
            </div>
            <div>
              {{ reservation.priceLabel }}
            </div>
          </div>

          <hr v-if="reservation.customFields" class="my-2">

          <template v-for="item in reservation.customFields" :key="item.idCustomField">
            <div v-if="item.customerVisible" class="text-sm flex font-semibold mb-1">
              <div class="flex-grow uppercase">
                {{ item.name }}
              </div>
              <div>
                {{ item.valueLabel || '-' }}
              </div>
            </div>
          </template>

          <hr class="my-2">

          <template v-for="service in reservation.services" :key="service.idReservationService">
            <div class="text-sm flex font-semibold mb-1">
              <div>
                {{ $t('components.reservation.actions.print.label', { time: $date.minutes(service.startTime), title: service.service.title, name: service.employee.displayName }) }}
              </div>
            </div>
          </template>
        </div>
      </div>
    </o-scroll>
  </o-modal>
</template>

<script setup lang="ts">
const { $auth, $print, $date } = useNuxtApp()

const modal = ref<any>(null)

const reservation = ref<any>(null)

const location = computed(() => {
  return $auth.info.location
})

const title = computed(() => {
  return location.value.title
})

const logo = computed(() => {
  return location.value.images?.square
})

const address = computed(() => {
  return location.value.address
})

function open(res: any) {
  reservation.value = res

  modal.value.open()
}

function handlePrint() {
  const content = document.getElementById('receipt-content')!.innerHTML
  $print(content)
}

defineExpose({ open })
</script>

<style lang="scss">
.receipt {
  $triangle-size: 4px;
  $stop1: $triangle-size * 1.42;
  $stop2: $triangle-size * 0.7;
  $stop1r: $stop1 + 0.01;
  $stop2r: $stop2 + 0.01;
  background:
    linear-gradient(135deg, transparent #{$stop1}, white #{$stop1r}) top left,
    linear-gradient(45deg, white #{$stop2}, transparent #{$stop2r}) top left,
    linear-gradient(135deg, white #{$stop2}, transparent #{$stop2r}) bottom left,
    linear-gradient(45deg, transparent #{$stop1}, white #{$stop1r}) bottom left;
  background-repeat: repeat-x;
  background-size: ($triangle-size * 2) $triangle-size;
  padding: $triangle-size 0;

  &-list {
    // You could add another linear-gradient for the white background
    // but background on this child div keeps the code MUCH simpler
    background-color: white;
  }
}
</style>
